import { render } from "./MyList.vue?vue&type=template&id=dc048c8e&ts=true"
import script from "./MyList.vue?vue&type=script&lang=ts"
export * from "./MyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__